<script setup>
import BatchStatsComponent from "@/Components/Payments/BatchStatsComponent.vue";
import SpecificBatchComponent from "@/Components/Payments/SpecificBatchComponent.vue";
import {useRoute} from "vue-router";
import {Permissions} from "@/Utils/Permissions";
import {onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
const route = useRoute();

const data = reactive({
  loading: true,
  exists: false
});

const checkExists = () => {
  data.loading = true;
  data.exists = false;
  ApiWrapper.post('payments', 'batch-exists', {
    batchId: route.params.id
  })
    .then((response) => {
      data.exists = true;
    })
    .catch((e)=>{
      data.exists = false;
    })
    .finally(()=>{
      data.loading = false;
    });

}
onMounted(() => {
  checkExists();
});

</script>

<template>
  <template v-if="data.loading">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-skeleton-loader type="card"></v-skeleton-loader>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && !data.exists">
    <v-row>
    <v-col cols="12">
      <v-container fluid>
        <v-card class="elevation-2" height="auto" width="auto">
          <v-alert title="Not Found" text="The specified batch could not be found" type="error"></v-alert>
        </v-card>
      </v-container>
    </v-col>
  </v-row>
  </template>

  <template v-if="!data.loading && data.exists">
    <v-row v-if="Permissions.checkPermissions(['payments.stats-batch'])">
      <v-col cols="12">
        <BatchStatsComponent :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
    <v-row v-if="Permissions.checkPermissions(['payments.read-batch'])">
      <v-col cols="12">
        <SpecificBatchComponent :contextIdA="route.params.id"/>
      </v-col>
    </v-row>
  </template>
</template>

<style scoped>

</style>